.context-menu-container{position:absolute}.context-menu-button{display:block}.menu-item{display:flex;justify-content:space-between;gap:2rem;width:100%}
/*# sourceMappingURL=context-menu.component.css.map */
